// TODO: right now it's exactly what diagnostics.js is doing. However, I don't think it's actually 100% right.
// We should register an onreadystatechange callback and see the actual response from the server (should be 200 OK).
export function uploadLogs(
  logs: string,
  remoteUlsEndpoint: string,
  async: boolean
): void {
  if (!remoteUlsEndpoint) {
    return;
  }

  // if navigator.sendBeacon is available in the browser, use it to upload the logs
  const navigator = window.navigator;
  if (navigator && navigator.sendBeacon) {
    try {
      navigator.sendBeacon(remoteUlsEndpoint, logs);
      return;
    } catch {}
  }

  uploadViaXmlHttpRequest(logs, remoteUlsEndpoint, async);
}

function uploadViaXmlHttpRequest(
  logs: string,
  remoteUlsEndpoint: string,
  async: boolean
): void {
  const request = new XMLHttpRequest();
  if (
    request.readyState === XMLHttpRequest.UNSENT ||
    request.readyState === XMLHttpRequest.DONE
  ) {
    request.open("POST", remoteUlsEndpoint, async);
    // Keep this a simple request by not adding any custom headers. This avoids the preflight OPTIONS request.
    // Only start sending custom headers if absolutely necessary for the server to handle to request.
    // CORS Simple Requests:https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Simple_requests

    request.send(logs);
  }
}
